import './polyfills';
import './header';
import './ageGate';
import './forgot-password';
import './newsletterForm';
import './nicotineWarning';
import '../../vendor/segment';
import './surveyForm';
import './sign-in';
import './country-selector';
import './store-locale-selector';
import './cookie-policy';

import api from 'api/ApiClient';
import GDPRBanner from './gdpr-banner';

const gdprBanner = new GDPRBanner();

const geo = gon.geo_location;
gdprBanner.showGdprBannerIfNecessary(geo);

const customAttributes = geo
  ? {
      zip: geo.zip,
      city: geo.city,
      country_code: geo.country_code,
      is_eu: geo.is_eu,
    }
  : {};

api.fetchSplitTreatments(customAttributes);



// WEBPACK FOOTER //
// ./app/javascript/apps/application/index.js